// vendor
import { Module } from "vuex";
// project
import * as JWT from "@/utils/jwt";
import * as AuthAPI from "@/services/api/auth";

type State = {
	token:string|null
}

type AuthTokenBody = {
	user:{
		email:string
	}
}

export const Auth:Module<State, {}> = {
	namespaced:false,
	state: {
		token:null
	},
	getters: {
		token(state:any){
			return state.token;
		},
		authenticated(state:any){
			return Boolean(state.token);
		},
		email(state:any){
			if(!state.token){ return ""; }
			const payload = JWT.parse<AuthTokenBody>(state.token)
			return payload.user.email;
		}
	},
	mutations:{
		setToken(state:any, token:any){
			state.token = token;
			if(token){
				localStorage.setItem("auth", token);
			}else{
				localStorage.removeItem("auth");
			}
		}
	},
	actions:{
		initialize({ commit }:any){
			let saved = localStorage.getItem("auth");
			if(saved) {
				commit("setToken", saved)
			}
		},
		async login({ commit }:any, { email, password }:any){
			const { token } = await AuthAPI.loginUser({ email, password });
			commit("setToken", token);
		},
		async logout({commit}:any){
			commit("setToken", null);
		}
	}

}